import { render, staticRenderFns } from "./versionAndRelease.vue?vue&type=template&id=464526da&scoped=true"
import script from "./versionAndRelease.vue?vue&type=script&lang=js"
export * from "./versionAndRelease.vue?vue&type=script&lang=js"
import style0 from "./versionAndRelease.vue?vue&type=style&index=0&id=464526da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464526da",
  null
  
)

export default component.exports